//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[],[[[],"InitModule",{R_:{errorID:''}},0,0],[[],"InitPartingSettings",{},0,0],[[],"PerformSyncTasks",{},0,0],[[],"PerformSyncTasksOnExit",{},0,0],[[],"SetUpdateLock",{},0,0],[["doUpdate"],"ResetUpdateLock",{},1,0],[[],"GetPartingManagerDataStatus",{R_:{pmDataStatus:''}},0,0],[["pmDataStatus"],"SetPartingManagerDataStatus",{},1,0],[[],"GetInPartingCommand",{R_:{inPartingCommand:''}},0,0],[["inPartingCommand"],"SetInPartingCommand",{},1,0],[[],"UpdatePartingNavigator",{},0,0],[["registerType"],"RegisterUndoIds",{},1,0],[["registerPostUNDO"],"RegisterWtcPostUndoCallback",{},1,0],[["deleteMesh"],"DeleteTransientMeshes",{},1,0]],[]];
SPLM.Tooling.MWPartingManagerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.MWPartingManagerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.MWPartingManagerBuilder.DataStatus = Object.freeze({
    "NotFreed" : "NotFreed", "Freed" : "Freed", "ForceUpdate" : "ForceUpdate"});

SPLM.Tooling.MWPartingManagerBuilder.RegisterType = Object.freeze({
    "Init" : "Init", "Current" : "Current", "Clear" : "Clear"});

export default SPLM;